import { action, atom, reatomBoolean, withReset } from '@reatom/framework'
import { withLocalStorage } from '@reatom/persist-web-storage'

import { Data } from '@blade/std-lib'
import { selectedNetworkAtom, setNetworkAction } from '@root/entities/network'
import { pairFocusEvent } from '@root/entities/pair/atoms'
import { TradeRoute } from '@root/features/routing'
import { STORAGE_PREFIX } from '@root/shared'
import {
  browserHistory,
  routerActions,
  routerLocationAtom,
} from '@root/shared/lib/react-router'

import { transactionConfirmationReaction } from './reatom-trading-confirmation'
import {
  extractTradingPairFromRouter,
  syncTradingPairWithRouterAction,
  syncTradingPairWithRouterReaction,
} from './reatom-trading-pair-address'

export const initializeTradingAction = action((ctx) => {
  // Change network if url network is different from current network
  const params = extractTradingPairFromRouter(browserHistory.location)

  if (params && params.network !== ctx.get(selectedNetworkAtom)) {
    setNetworkAction(ctx, params.network)
  }

  routerLocationAtom.onChange(syncTradingPairWithRouterAction)
  syncTradingPairWithRouterReaction(ctx)
  transactionConfirmationReaction(ctx)
}, 'initializeTradingAction')

// TODO: initiate exclusively
pairFocusEvent.onCall((ctx, _, [{ address, network }]) => {
  routerActions.navigate(
    ctx,
    TradeRoute.build({ pairAddress: address, network }),
  )
})

const TRADE_PRICE_TYPE_KEY = `${STORAGE_PREFIX}/v1/tradePriceType`

export type TradePriceType = 'absolute' | 'market-cap'
export const matchTradePriceType = Data.matchString<TradePriceType>()

export const tradePriceType = atom<TradePriceType>(
  'market-cap',
  'tradePriceType',
).pipe(withReset(), withLocalStorage(TRADE_PRICE_TYPE_KEY))

export const showAllTimeHighChartLineAtom = reatomBoolean(
  false,
  'showAllTimeHighChartLineAtom',
)

export * from './reatom-trading-pair'
export * from './reatom-trading-pair-address'
export * from './reatom-trading-pair-audit'
export {
  skipShowAuditAction,
  skipShowAuditAtom,
} from './reatom-trading-pair-audit'
